export default __webpack_public_path__ + "static/media/04.8af2a2c1.webp";